"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TestimonialTemplate1;

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

var _react = _interopRequireWildcard(require("react"));

var _Card = _interopRequireDefault(require("./../../CardsComponent/Card1"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function TestimonialTemplate1(props) {
  var _state$section8, _state$section8$secti, _state$section9, _state$section9$users, _state$section10;

  const [state, setState] = (0, _react.useState)({
    section: {}
  });
  const [isSourceWebConsole, setSource] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setState({
      section: props === null || props === void 0 ? void 0 : props.section
    });

    if ((props === null || props === void 0 ? void 0 : props.source) === "web-console") {
      setSource(true);
    }
  }, [props]);

  const onWrapperClick = dataReceived => {
    if (props.onElementClick && isSourceWebConsole) {
      props.onElementClick(_objectSpread(_objectSpread({}, dataReceived), {}, {
        templateId: props.templateId
      }));
    }
  };

  const renderCard = cardTemplateId => {
    var _state$section, _state$section$users_, _state$section2, _state$section3, _state$section4, _state$section4$users, _state$section5;

    switch (cardTemplateId) {
      case 1:
        return /*#__PURE__*/_react.default.createElement(_Card.default, {
          list: (_state$section = state.section) === null || _state$section === void 0 ? void 0 : (_state$section$users_ = _state$section.users_list) === null || _state$section$users_ === void 0 ? void 0 : _state$section$users_.list,
          maxItems: (_state$section2 = state.section) === null || _state$section2 === void 0 ? void 0 : _state$section2.max_items,
          data: state.section,
          slug: (_state$section3 = state.section) === null || _state$section3 === void 0 ? void 0 : _state$section3.slug,
          isSourceWebConsole: isSourceWebConsole,
          onWrapperClick: onWrapperClick
        });

      case 2:
        return /*#__PURE__*/_react.default.createElement(_Card.default, {
          list: (_state$section4 = state.section) === null || _state$section4 === void 0 ? void 0 : (_state$section4$users = _state$section4.users_list) === null || _state$section4$users === void 0 ? void 0 : _state$section4$users.list,
          maxItems: (_state$section5 = state.section) === null || _state$section5 === void 0 ? void 0 : _state$section5.max_items,
          isSourceWebConsole: isSourceWebConsole,
          onWrapperClick: onWrapperClick
        });

      default:
        return "";
    }
  };

  const onViewMoreBtnClick = () => {
    var _state$section6;

    if (!isSourceWebConsole && (_state$section6 = state.section) !== null && _state$section6 !== void 0 && _state$section6.slug) {
      var _state$section7;

      const link = window.location.href.split("");
      const ifLastCharSlash = link[link.length - 1] === "/";
      window.location.href = "".concat(window.location.href).concat(ifLastCharSlash ? "" : "/", "p/").concat((_state$section7 = state.section) === null || _state$section7 === void 0 ? void 0 : _state$section7.slug);
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    id: "testimonial_section_1",
    className: "testimonial-main-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "section_title",
    className: "black section-title tc",
    onClick: () => onWrapperClick({
      parentKey: "",
      itemIndex: null,
      keyToBeUpdated: "section_title",
      childKeyToBeReplaced: "display_text"
    })
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "fw6 heading ".concat(isSourceWebConsole ? "title-hover" : "")
  }, (_state$section8 = state.section) === null || _state$section8 === void 0 ? void 0 : (_state$section8$secti = _state$section8.section_title) === null || _state$section8$secti === void 0 ? void 0 : _state$section8$secti.display_text, " ")), renderCard((_state$section9 = state.section) === null || _state$section9 === void 0 ? void 0 : (_state$section9$users = _state$section9.users_list) === null || _state$section9$users === void 0 ? void 0 : _state$section9$users.cardTemplateId), (_state$section10 = state.section) !== null && _state$section10 !== void 0 && _state$section10.max_items ? /*#__PURE__*/_react.default.createElement("section", {
    className: "flex justify-center items-center view-more-btn--container"
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: onViewMoreBtnClick,
    className: "view-more-btn"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "w-100 tc"
  }, "View More"))) : null);
}